import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthorizedFilesService {
    private baseApiUrl: string = '/api/v1/authorized-files/';

    constructor(private httpClient: HttpClient) {}

    getFile(id: string): Observable<Blob> {
        return this.httpClient.get(`${this.baseApiUrl}${id}`, { responseType: 'blob' });
    }
}
